import React, { FunctionComponent } from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import IconSparkles from "@/assets/sparkles.svg?url";

export const NewBadge: FunctionComponent = () => {
	const { t } = useTranslation();
	return (
		<Box display="flex" alignItems="center" textColor="#2B0086" bg="#F3DBFF" borderRadius={"md"} px={2} py={0.5} columnGap={1.5}>
			<Text fontSize="xs" fontWeight={600}>
				{t("classroomDetails.newBadge")}
			</Text>
			<Image src={IconSparkles} alt="" width={3} />
		</Box>
	);
};
